import { useTracking } from '@edreamsodigeo/frontend-core';
import { RESULTS_CATEGORY } from 'clientState/providers';
import { getCarrier, getTabLabel, getRoute } from './helpers/utils';
import { useSorting } from '@components/Sorting/Provider';

export const useFlightOfTheDayTracking = (trackingType) => {
  const { trackEvent } = useTracking();
  const { sorting } = useSorting();

  const trackFlightOfTheDay = (itinerary, position, isFlightOfTheDayShown) => {
    const eventTrigger = trackingType === 'click' ? 'click' : 'load';
    const itineraryPrice = Math.round(itinerary?.price?.amount || 0);
    const isOneWay = itinerary?.legs?.length === 1;
    const departureCarrier = getCarrier(itinerary?.legs?.[0]?.segments, false);
    const destinationCarrier = getCarrier(
      itinerary?.legs?.[1]?.segments,
      isOneWay
    );
    const cheapestPosition = itinerary?.priceSortingPosition || 'NA';
    const currentTab = getTabLabel(sorting);
    const route = getRoute(itinerary);

    trackEvent({
      category: RESULTS_CATEGORY,
      action: 'flight_labels',
      label: `flight_label_${eventTrigger}:FoD_m:MP_pr:${itineraryPrice}_pos:${
        position + 1
      }_ad:${departureCarrier}_ar:${destinationCarrier}_pc:${cheapestPosition}_tab:${currentTab}_r:${route}_s:${
        isFlightOfTheDayShown ? 'Y' : 'N'
      }`,
    });
  };

  return { trackFlightOfTheDay };
};
